const ECO_FEE_CATEGORY = "EcoFee";
const ECO_FEE_EXCLUDE_TOKEN = "{feeAmount}";
export {
  ECO_FEE_CATEGORY,
  ECO_FEE_EXCLUDE_TOKEN
};
